<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentEditTeam /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/team/dashboard/HeaderDash.vue'
import SideMenu from '@/components/team/dashboard/SideMenu.vue'
import ContentEditTeam from '@/components/team/dashboard/modules/team/ContentEditTeam.vue'

export default 
{
  name: 'EditTeam',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentEditTeam
  }
}
</script>
<style>

</style>
